import { Helmet } from "react-helmet";


import './css/Cats.css'

export default function Home() {

	return (
		<>
            <Helmet>
                <title>404 </title>
            </Helmet>

			

		</>
	)
}
